import React from "react";
import styled from "styled-components";
import ReactCrop from 'react-image-crop';

import media from "../../helpers/media";
import { getCroppedImg,createObjectURL,blobToBase64 } from "./cropImage";
import 'react-image-crop/dist/ReactCrop.css';

export class ImagePicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            crop: {
                unit: '%',
                width: 50,
                height: 50,
                x: 25,
                y: 25
              }
        }
    }

    handleClick(e) {
        this.refs.fileUploader.click();
    }

    handleChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            this.setState({
                file: e.target.files[0]
            })
            const reader = new FileReader()
            reader.addEventListener(
                'load',
                () =>
                    this.setState({
                        src: reader.result,
                    }),
                false
            )
            reader.readAsDataURL(e.target.files[0])
        }
    }


    onCropChange = crop => {
        this.setState({ crop })
    }

    saveImage = async () => {
        const { file, crop } = this.state;
        try {
            let image = new Image();
            image.src = createObjectURL(file);
            image.onload = async (e) =>{
                var mybase64resized = await getCroppedImg(image, crop, "myProfile");
                const base64Image =await blobToBase64(mybase64resized);
                this.props.saveImage("imageData", base64Image)
                this.setState({
                    src: null
                });
            }
        } catch (e) {
            console.error("opps", e)
        }
    }

    render() {
        const { src, crop } = this.state;
        return <>
            <Img onClick={this.handleClick} src={!!this.props.value ? this.props.value : "https://www.w3schools.com/howto/img_avatar.png"} alt="Avatar" />
            <input type="file" id="file" ref="fileUploader" onChange={this.handleChange} style={{ display: "none" }} />
            {src &&
                <BlurContainer>
                    <ImageCrop>
                            <ReactCrop
                                src={src}
                                crop={crop}
                                ruleOfThirds
                                onImageLoaded={this.onImageLoaded}
                                onChange={this.onCropChange}
                            />
                        <Button onClick={this.saveImage}>Done</Button>
                    </ImageCrop>
                </BlurContainer>
            }
        </>
    }
}

const Img = styled.img`
  border-radius: 50%;
  width: 100px;
  height: 100px;
  object-fit: cover;
  border:2px solid rebeccapurple;
`;

const BlurContainer = styled.div`
    position:absolute;
    width: 100%;
    height: 100% !important;
    background-color: rgba(0,0,0,0.7);
    padding-top: 35px;
    /* overflow: scroll; */
    top: 0px;
    left: 0px;
    right: 0px;
`;

const ImageCrop = styled.div`
    position:fixed;
    background-color:#e3e2e6;
    height:70%;
    width:90%;
    box-shadow: 0px 0px 4px -2px rgba(0,0,0,0.75);
    left: 50%;
    top:50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius:3px;
    @media ${media.tablet}{
        min-height:50%;
        width:50%;
    }
`;

const Button = styled.button`
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    height:20px;
    background-color:rebeccapurple;
    color:white;
    border-radius:2px;
    height:30px;
    width:70px;
    border: none;
`;